module.exports = __webpack_public_path__ + "d469a2fc2ab24a9423cfd1dfd3d6dc3f.svg";